import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { performLeavingAction } from './leavingDialog/performLeavingAction';

export const closeSidePanel: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    dispatch(performLeavingAction, {
      callback: () => {
        cmdContext.updateState((draft) => {
          draft.sidePanel.open = false;
          draft.layoutSettings.presetEditMode = false;
        });
      },
    });
  };
